var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from "moment";
export const S3Service = {
    helpers: {
        generateBucketName: function () {
            if (process.env.REACT_APP_ENV === "development") {
                return process.env.REACT_APP_AWS_BUCKET_NAME_DEV;
            }
            else if (process.env.REACT_APP_ENV === "production") {
                return process.env.REACT_APP_AWS_BUCKET_NAME_PROD;
            }
            else if (process.env.REACT_APP_ENV === "staging") {
                return process.env.REACT_APP_AWS_BUCKET_NAME_STAGING;
            }
            return process.env.REACT_APP_AWS_BUCKET_NAME_DEV;
        },
    },
    uploader: function (content, dirName) {
        return __awaiter(this, void 0, void 0, function* () {
            if (content === null ||
                JSON.parse(content).length === 0 ||
                !content ||
                content === "undefined") {
                return;
            }
            AWS === null || AWS === void 0 ? void 0 : AWS.config.update({
                region: process.env.REACT_APP_AWS_BUCKET_REGION,
                accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
                secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
            });
            const params = {
                Bucket: this.helpers.generateBucketName(),
                Key: `${dirName}.txt`,
                Body: content,
            };
            const s3 = new AWS.S3();
            try {
                yield s3
                    .putObject(params)
                    .promise()
                    .then(() => {
                    sessionStorage.removeItem("logs");
                })
                    .catch((error) => {
                    // Handle any errors that occurred during the promise execution
                    console.error("An error occurred:", error);
                    // Handle the error...
                });
            }
            catch (error) {
                console.error("Error uploading file:", error);
            }
        });
    },
    payloadGeneratorUploader(tenantName, user, platformName, action, interviewTitleId, attempt) {
        const isLocal = window.location.hostname.includes("localhost");
        if (isLocal) {
            console.log("LocalHost: We are not uploading logs");
            return;
        }
        const logContent = sessionStorage.getItem("logs");
        const attemptFolder = attempt ? `attempt-${attempt}` : "";
        const dateFolder = moment(new Date()).format("DD MMM YYYY");
        const folders = [
            tenantName,
            platformName,
            user.phoneNumber,
            interviewTitleId,
            attemptFolder,
            dateFolder,
        ]
            .filter(Boolean)
            .join("/");
        const filePath = `${folders}/${action}_${user.id}_${new Date()}`;
        this.uploader(logContent, filePath);
    },
    checkSessionStorageLimit: function (tenantName, user, platformName, action, interviewTitleId) {
        const sessionLogData = sessionStorage.getItem("logs");
        if (sessionLogData === null ||
            sessionLogData === "undefined" ||
            sessionLogData === undefined ||
            sessionLogData === "null") {
            return;
        }
        if (JSON.parse(sessionLogData).length > 25) {
            this.payloadGeneratorUploader(tenantName, user, platformName, action, interviewTitleId);
        }
    },
};
